import React from "react";
import { Area, ComposedChart, Line, ResponsiveContainer, Tooltip } from "recharts";

import { Box } from "@puzzle/ve";
import { S, vars } from "@puzzle/theme";

import { PercentageLineGraphToolTip } from "./GraphToolTip";
import { GraphDateRange } from "./GraphDateRange";

export type PercentageValues = {
  date: string;
  amount: string | null | undefined;
};

export const PercentageLineGraph = ({
  inData,
  innerHeight = "85%", // Hack for adjusting specific charts. Need to revisit.
  toolTipLabel,
}: {
  inData?: PercentageValues[];
  innerHeight?: string;
  toolTipLabel: string;
}) => {
  if (!inData || inData.length === 0) {
    return null; // shows nothing until the graph is ready
  }

  const startDate = inData[0]?.date;
  const endDate = inData[inData.length - 1]?.date;

  return (
    <Box
      css={{
        width: "100%",
        height: "100%",
        paddingLeft: S.$1,
        paddingRight: S.$1,
      }}
    >
      <ResponsiveContainer width="100%" height={innerHeight}>
        <ComposedChart
          data={inData.map((x) => ({
            date: x.date,
            value: x.amount || "0",
            noValue: x.amount === null || x.amount === undefined,
          }))}
        >
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={vars.colors["surface-special-base"]} stopOpacity={1.0} />
              <stop offset="100%" stopColor={vars.colors.purple900V2} stopOpacity={1.0} />
            </linearGradient>
          </defs>
          <Area type="monotone" dataKey="value" fill="url(#colorUv)" isAnimationActive={false} />
          <Line
            type="monotone"
            dataKey="value"
            stroke={vars.colors["outline-special-base"]}
            strokeWidth={3}
            dot={false}
            isAnimationActive={false}
          />

          <Tooltip
            wrapperStyle={{ outline: "none" }}
            cursor={false}
            content={({ active, payload }) => {
              if (active && payload && payload.length) {
                return (
                  <PercentageLineGraphToolTip
                    date={payload[0].payload.date}
                    value={payload[0].payload.value}
                    label={toolTipLabel}
                    showNoValue={payload[0].payload.noValue}
                    noValueLabel="No revenue for this period"
                  />
                );
              }

              return null;
            }}
          />
        </ComposedChart>
      </ResponsiveContainer>
      <GraphDateRange
        startDate={startDate}
        endDate={endDate}
        css={{ paddingLeft: S.$1h, paddingRight: S.$1h, marginTop: "6px" }}
      />
    </Box>
  );
};
